// extracted by mini-css-extract-plugin
export var component = "VideoIframe-module--component--sYYKd";